__webpack_require__.p = "https://assets-01.periodica.press/fbdb922-26097606485/";